<template>
  <v-card-actions class="actions hidden-sm-and-down" id="card-actions-desktop">
    <v-container fluid>
      <v-layout wrap align-center class="card-actions">
        <v-flex sm12 class="text-left info-icons">
          <!-- scheduler icon -->
          <v-tooltip top>
            <template v-slot:activator="{ on }" v-if="scheduler">
              <v-icon v-on="on" class="ml-2 mb-2" left small color="#881E98"
                >far fa-clock</v-icon
              >
            </template>
            <span>Scheduler is active</span>
          </v-tooltip>

          <!-- shared icon -->
          <v-tooltip
            top
            v-if="
              (sharedCount > 0 && isOwner) ||
              (sharedCount - 1 > 0 && accessLevel)
            "
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ml-2 mb-2" left small color="#881E98"
                >far fa-user-friends</v-icon
              >
            </template>
            <span v-if="isOwner"
              >Environment is shared with {{ sharedCount }}
              {{ sharedCount > 1 ? "other users" : "other user" }}
            </span>
            <span v-else
              >Environment is shared with {{ sharedCount - 1 }}
              {{ sharedCount > 1 ? "other users" : "other user" }}
            </span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <!-- <v-icon v-on="on" class="ml-2 mb-2" left small color="#881E98">far fa-server</v-icon> -->
              <v-chip
                v-on="on"
                class="pa-2 ml-2 mt-n2 info-chip"
                outlined
                small
                >{{ environment.InstanceTypeId ? "VM" : "K8S" }}</v-chip
              >
            </template>
            <span
              >Environment is running on
              {{ environment.InstanceTypeId ? "VM" : "K8S" }}</span
            >
          </v-tooltip>
          <v-chip
            small
            outlined
            class="ml-2 pa-2 connected-chip"
            v-if="environment.ConnectedId"
            >CONNECTED</v-chip
          >
        </v-flex>
        <div style="display: flex" v-if="environment.ApplicationLogin">
          <div data-v-7dad852b="" style="margin-right: 25px">
            <p data-v-7dad852b="" id="login">
              Login:
              <span data-v-7dad852b="" class="creds-style font-weight-bold">{{
                environment.ApplicationLogin
              }}</span>
            </p>
          </div>
          <div data-v-7dad852b="">
            <div data-v-7dad852b="">
              <p data-v-7dad852b="" id="password">
                Password:
                <span
                  data-v-7dad852b=""
                  class="creds-style font-weight-bold"
                  :id="'password-' + environment.Id"
                  @click="copyPassword"
                  >{{ password }}</span
                >
                <v-icon
                  data-v-7dad852b=""
                  right
                  small
                  class="copy-icon"
                  @click="togglePassword"
                  :class="hiddenPassword ? 'far fa-eye' : 'fas fa-eye-slash'"
                ></v-icon>
              </p>
            </div>
          </div>
        </div>
        <v-flex justify-end d-flex>
          <v-btn
            class="action-button font-weight-bold"
            text
            @click="onShare"
            :disabled="!environment.AccessLevel && environment.OwnerSub !== sub"
            >Share <v-icon right id="icon-style">far fa-share</v-icon>
          </v-btn>
          <v-btn
            class="action-button font-weight-bold"
            :to="
              environment.ConnectedId
                ? '/environments/connected/' +
                  environment.ConnectedId +
                  '/details'
                : '/environments/' + environment.Id + '/details'
            "
            text
            >Details
            <v-icon right id="icon-style">fas fa-chevron-double-right</v-icon>
          </v-btn>
          <Share
            :showShareDialog.sync="showShareDialog"
            :environmentId="
              environment.ConnectedId ? environment.ConnectedId : environment.Id
            "
            :users="users"
            :sharedEnvironmentWith="sharedEnvironmentWith"
            @cancelShareDialog="cancelShareDialog"
            @confirmShareDialog="confirmShareDialog"
            :shareBtnloading="shareBtnloading"
          />
          <v-overlay :value="shareModalLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-actions>
</template>

<script>
import Share from "../Share";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      hiddenPassword: true,
      hashedPassword: "********",
      showShareDialog: false,
      shareBtnloading: false,
      shareModalLoading: false,
    };
  },
  props: [
    "environment",
    "password",
    "scheduler",
    "sharedCount",
    "accessLevel",
    "isOwner",
  ],
  components: { Share },
  computed: {
    ...mapGetters([
      "sub",
      "sharedEnvironmentWith",
      "users",
      "connectedEnvironmentDetails",
    ]),
  },
  methods: {
    ...mapActions([
      "getUserSub",
      "getUsers",
      "shareEnvironment",
      "shareConnectedEnvironment",
      "getSharedEnvironmentWith",
      "stopSharingEnvironment",
      "stopSharingConnectedEnvironment",
      "getEnvironments",
      "getConnectedEnvironments",
      "getConnectedEnvironmentDetails",
    ]),
    togglePassword() {
      this.$emit("togglePassword");
    },
    copyPassword() {
      this.$emit("copyPassword");
    },
    async onShare() {
      this.shareModalLoading = true;
      console.log(this.environment.ConnectedId);
      if (this.environment.ConnectedId)
        await this.getConnectedEnvironmentDetails(this.environment.ConnectedId);
      await Promise.all([
        this.getUsers(),
        this.getSharedEnvironmentWith(
          this.environment.ConnectedId
            ? this.connectedEnvironmentDetails.environments[0].EnvironmentId
            : this.environment.Id
        ),
      ]);
      console.log(this.sharedEnvironmentWith);
      this.shareModalLoading = false;
      this.showShareDialog = !this.showShareDialog;
    },
    cancelShareDialog() {
      this.showShareDialog = false;
    },
    async confirmShareDialog(data) {
      this.shareBtnloading = true;
      if (data.addedMembers.length) {
        if (this.environment.ConnectedId) {
          const params = {
            emails: data.addedMembers,
            connectedEnvId: data.environmentId,
          };
          await this.shareConnectedEnvironment(params);
          await this.getConnectedEnvironments();
        } else {
          data.emails = data.addedMembers;
          const { addedMembers, removedMembers, ...params } = data;
          await this.shareEnvironment(params);
          await this.getEnvironments();
        }
      }
      if (data.removedMembers.length) {
        if (this.environment.ConnectedId) {
          const params = {
            emails: data.removedMembers,
            connectedEnvId: data.environmentId,
          };
          await this.stopSharingConnectedEnvironment(params);
          await this.getConnectedEnvironments();
        } else {
          data.emails = data.removedMembers;
          const { addedMembers, removedMembers, ...params } = data;
          await this.stopSharingEnvironment(params);
          await this.getEnvironments();
        }
      }
      this.showShareDialog = false;
      this.shareBtnloading = false;
    },
  },
  beforeMount() {
    this.getUserSub();
  },
};
</script>

<style scoped>
.action-button {
  text-transform: none;
}

.v-chip {
  margin: 0;
  padding: 0;
}

.info-chip {
  color: #881e98;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #881e98 !important;
  height: 18.5px;
}

.connected-chip {
  color: #ec0625;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #ec0625 !important;
  height: 18.5px;
  margin-bottom: 8px;
}
</style>
